import {ACTION_TYPES} from "../consts";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ComponentController} from "../../infrastructure/controllers/component-controller";
import {APP} from "../app/consts";

export class MainLogoClickHandler extends ActionHandler {
  type = ACTION_TYPES.mainLogoClick;
  controller: ComponentController;

  static injectables = [...ActionHandler.injectables];

  async action(params = {}) {
    params.source = APP.ANALYTICS.SOURCES[this.state.currentLinkModel?.name]

    this.controller.action(ACTION_TYPES.mainLogoClickAnalytics, {...params});
    this.controller.action(ACTION_TYPES.onGameContextClose)
  }
}
